const testimonialsByLang = {
  en: [
    {
      industry: 'Insurance',
      pillColor: 'accent',
      quote: 'Reduced training time by 40%',
      description: 'AI coaching helped our new reps ramp up faster than ever before. The personalized feedback loop cut our onboarding from weeks to days.',
      author: 'Sales Director',
      company: 'Insurance Co.',
      metric: '40%',
      metricLabel: 'faster onboarding',
    },
    {
      industry: 'Real Estate',
      pillColor: 'blue',
      quote: '10x improvement in QA coverage',
      description: 'Audio playback and AI analysis lets us review every client interaction — something that was impossible with manual spot checks.',
      author: 'VP of Sales',
      company: 'Property Group',
      metric: '10x',
      metricLabel: 'QA coverage',
    },
    {
      industry: 'Automotive',
      pillColor: 'green',
      quote: 'Finally, a standardized sales process',
      description: 'Survey forms and performance scoring gave us visibility we never had. Every dealership now follows the same proven playbook.',
      author: 'Head of Sales',
      company: 'Auto Dealer Network',
      metric: '100%',
      metricLabel: 'process compliance',
    },
    {
      industry: 'Financial Services',
      pillColor: 'purple',
      quote: 'Cut follow-up time by 60%',
      description: 'Automated WhatsApp and email follow-ups mean our reps spend time selling, not typing. Response rates have never been higher.',
      author: 'Regional Manager',
      company: 'Finance Corp.',
      metric: '60%',
      metricLabel: 'less follow-up time',
    },
    {
      industry: 'Education',
      pillColor: 'accent',
      quote: 'Data-driven coaching at scale',
      description: 'Training needs analysis pinpoints exactly where each counselor needs improvement. No more guesswork in professional development.',
      author: 'Director of Admissions',
      company: 'University Group',
      metric: '3x',
      metricLabel: 'coaching efficiency',
    },
  ],
  zh: [
    {
      industry: '保险行业',
      pillColor: 'accent',
      quote: '培训时间缩短 40%',
      description: 'AI 辅导让新人上手速度前所未有地快。个性化反馈让入职培训从几周缩短到几天。',
      author: '销售总监',
      company: '某保险公司',
      metric: '40%',
      metricLabel: '更快上岗',
    },
    {
      industry: '房地产',
      pillColor: 'blue',
      quote: '质检覆盖率提升 10 倍',
      description: '录音回放加 AI 分析让我们能复盘每一次客户沟通——这是人工抽查永远做不到的。',
      author: '销售副总裁',
      company: '某地产集团',
      metric: '10x',
      metricLabel: '质检覆盖率',
    },
    {
      industry: '汽车行业',
      pillColor: 'green',
      quote: '终于有了标准化销售流程',
      description: '调研问卷和绩效评分带来了前所未有的可见度。如今每家门店都在执行同一套经过验证的打法。',
      author: '销售负责人',
      company: '某汽车经销商网络',
      metric: '100%',
      metricLabel: '流程合规率',
    },
    {
      industry: '金融服务',
      pillColor: 'purple',
      quote: '跟进时间节省 60%',
      description: '自动化的 WhatsApp 与邮件跟进让销售专注于成单,而不是打字。客户回复率也创下新高。',
      author: '区域经理',
      company: '某金融公司',
      metric: '60%',
      metricLabel: '跟进时间减少',
    },
    {
      industry: '教育行业',
      pillColor: 'accent',
      quote: '规模化的数据驱动辅导',
      description: '培训需求分析精准定位每位咨询顾问的提升空间,让人才发展不再靠猜。',
      author: '招生总监',
      company: '某高校集团',
      metric: '3x',
      metricLabel: '辅导效率',
    },
  ],
};

export const getTestimonialData = (lang = 'en') =>
  testimonialsByLang[lang] || testimonialsByLang.en;

// Back-compat default export
const testimonialData = testimonialsByLang.en;
export default testimonialData;
